import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const Comparison = () => {
    return (
        <div className="comparison-wrapper">
            <div className="container">
                <div className="title xmb-2 d-block d-lg-none">
                    <div className="title-box just-text title-box-blue">
                        <div className="title-bg">
                            <h2 className="text">
                                مقایسه
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 col-lg-4 col-xl-3 xmt-4">
                        <div className="product-box position-relative xpx-4 xpt-12 xpb-4">
                            <div className="price-box position-absolute">
                                <span className="total-price persian-number">2,760,000 ت</span>
                            </div>
                            <div className="product-img xmb-4">
                                <img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                            </div>
                            <div className="product-title xmb-2">
                                <h3 className="title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                            </div>
                            <div className="color-range xmb-0 xmb-lg-8">
                                <span className="range" style={{background: "#192B3B"}}></span>
                                <span className="range" style={{background: "#F5F8FA"}}></span>
                                <span className="range" style={{background: "#1473E6"}}></span>
                            </div>
                            <div className="show-buy-product xmb-8 d-none d-lg-block">
                                <a href="#">
                                    مشاهده و خرید محصول
                                    <IconName name="chevron_left" className="icon"/>
                                </a>
                            </div>
                            <div className="info-product d-none d-lg-block">
                                <ul className="list-unstyled">
                                    <li>
                                         <span className="title-toggle">
                                            <IconName name="aspect_ratio" className="icon"/>
                                         صفحه‌ی نمایش
                                        </span>
                                        <p className="info-product">۶.۱ اینچ • ۸۲۸ × ۱۷۹۲ پیکسل</p>
                                    </li>
                                    <li>
                                              <span className="title-toggle">
                                <IconName name="straighten" className="icon"/>
                                ابعاد و وزن
                            </span>
                                        <p className="info-product">۸.۳ × ۷۵.۷ × ۱۵۰.۹ میلی‌متر• ۱۹۴ گرم</p>
                                    </li>
                                    <li>
                                                                    <span className="title-toggle">
                                <IconName name="battery_charging_full" className="icon"/>
                                مشخصات باتری
                            </span>
                                        <p className="info-product">باتری از نوع لیتیوم-یون با ظرفیت ۳۱۱۰
                                            میلی‌آمپرساعت</p>
                                    </li>
                                    <li>
                                              <span className="title-toggle">
                                <IconName name="memory" className="icon"/>
حافظه و ذخیره سازی                            </span>
                                        <p className="info-product">حافظه داخلی ۱۲۸ گیگ • رم ۴ گیگ</p>
                                    </li>
                                    <li>
                                                      <span className="title-toggle">
                                <IconName name="cpu" className="icon"/>
                                پردازنده
                            </span>
                                        <p className="info-product">Apple A13 Bionic (7 nm+) Chipset</p>
                                    </li>
                                    <li>
                                                             <span className="title-toggle">
                                <IconName name="camera_alt" className="icon"/>
                                دوربین عکاسی
                            </span>
                                        <p className="info-product">۱۲.۰ مگاپیکسل</p>
                                    </li>
                                    <li>
                                                        <span className="title-toggle">
                                <IconName name="videocam" className="icon"/>
                                فیلمبرداری
                            </span>
                                        <p className="info-product">رزولوشن 2160 × 3840 و سرعت 24/30/60 فریم بر ثانیه
                                            (2160p@24/30/60FPS)</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-lg-4 col-xl-3 xmt-4">
                        <div className="product-box position-relative xpx-4 xpt-12 xpb-4">
                            <div className="price-box position-absolute">
                                <span className="total-price persian-number">2,760,000 ت</span>
                            </div>
                            <div className="product-img xmb-4">
                                <img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                            </div>
                            <div className="product-title xmb-2">
                                <h3 className="title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                            </div>
                            <div className="color-range xmb-0 xmb-lg-8">
                                <span className="range" style={{background: "#192B3B"}}></span>
                                <span className="range" style={{background: "#F5F8FA"}}></span>
                                <span className="range" style={{background: "#1473E6"}}></span>
                            </div>
                            <div className="show-buy-product xmb-8 d-none d-lg-block">
                                <a href="#">
                                    مشاهده و خرید محصول
                                    <IconName name="chevron_left" className="icon"/>
                                </a>
                            </div>
                            <div className="info-product d-none d-lg-block">
                                <ul className="list-unstyled">
                                    <li>
                                         <span className="title-toggle">
                                            <IconName name="aspect_ratio" className="icon"/>
                                         صفحه‌ی نمایش
                                        </span>
                                        <p className="info-product">۶.۱ اینچ • ۸۲۸ × ۱۷۹۲ پیکسل</p>
                                    </li>
                                    <li>
                                              <span className="title-toggle">
                                <IconName name="straighten" className="icon"/>
                                ابعاد و وزن
                            </span>
                                        <p className="info-product">۸.۳ × ۷۵.۷ × ۱۵۰.۹ میلی‌متر• ۱۹۴ گرم</p>
                                    </li>
                                    <li>
                                                                    <span className="title-toggle">
                                <IconName name="battery_charging_full" className="icon"/>
                                مشخصات باتری
                            </span>
                                        <p className="info-product">باتری از نوع لیتیوم-یون با ظرفیت ۳۱۱۰
                                            میلی‌آمپرساعت</p>
                                    </li>
                                    <li>
                                              <span className="title-toggle">
                                <IconName name="memory" className="icon"/>
حافظه و ذخیره سازی                            </span>
                                        <p className="info-product">حافظه داخلی ۱۲۸ گیگ • رم ۴ گیگ</p>
                                    </li>
                                    <li>
                                                      <span className="title-toggle">
                                <IconName name="cpu" className="icon"/>
                                پردازنده
                            </span>
                                        <p className="info-product">Apple A13 Bionic (7 nm+) Chipset</p>
                                    </li>
                                    <li>
                                                             <span className="title-toggle">
                                <IconName name="camera_alt" className="icon"/>
                                دوربین عکاسی
                            </span>
                                        <p className="info-product">۱۲.۰ مگاپیکسل</p>
                                    </li>
                                    <li>
                                                        <span className="title-toggle">
                                <IconName name="videocam" className="icon"/>
                                فیلمبرداری
                            </span>
                                        <p className="info-product">رزولوشن 2160 × 3840 و سرعت 24/30/60 فریم بر ثانیه
                                            (2160p@24/30/60FPS)</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-xl-3 xmt-4 d-none d-lg-block">
                        <div className="product-box position-relative xpx-4 xpt-12 xpb-4">
                            <div className="price-box position-absolute">
                                <span className="total-price persian-number">2,760,000 ت</span>
                            </div>
                            <div className="product-img xmb-4">
                                <img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                            </div>
                            <div className="product-title xmb-2">
                                <h3 className="title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                            </div>
                            <div className="color-range xmb-8">
                                <span className="range" style={{background: "#192B3B"}}></span>
                                <span className="range" style={{background: "#F5F8FA"}}></span>
                                <span className="range" style={{background: "#1473E6"}}></span>
                            </div>
                            <div className="show-buy-product xmb-8">
                                <a href="#">
                                    مشاهده و خرید محصول
                                    <IconName name="chevron_left" className="icon"/>
                                </a>
                            </div>
                            <div className="info-product">
                                <ul className="list-unstyled">
                                    <li>
                                         <span className="title-toggle">
                                            <IconName name="aspect_ratio" className="icon"/>
                                         صفحه‌ی نمایش
                                        </span>
                                        <p className="info-product">۶.۱ اینچ • ۸۲۸ × ۱۷۹۲ پیکسل</p>
                                    </li>
                                    <li>
                                              <span className="title-toggle">
                                <IconName name="straighten" className="icon"/>
                                ابعاد و وزن
                            </span>
                                        <p className="info-product">۸.۳ × ۷۵.۷ × ۱۵۰.۹ میلی‌متر• ۱۹۴ گرم</p>
                                    </li>
                                    <li>
                                                                    <span className="title-toggle">
                                <IconName name="battery_charging_full" className="icon"/>
                                مشخصات باتری
                            </span>
                                        <p className="info-product">باتری از نوع لیتیوم-یون با ظرفیت ۳۱۱۰
                                            میلی‌آمپرساعت</p>
                                    </li>
                                    <li>
                                              <span className="title-toggle">
                                <IconName name="memory" className="icon"/>
حافظه و ذخیره سازی                            </span>
                                        <p className="info-product">حافظه داخلی ۱۲۸ گیگ • رم ۴ گیگ</p>
                                    </li>
                                    <li>
                                                      <span className="title-toggle">
                                <IconName name="cpu" className="icon"/>
                                پردازنده
                            </span>
                                        <p className="info-product">Apple A13 Bionic (7 nm+) Chipset</p>
                                    </li>
                                    <li>
                                                             <span className="title-toggle">
                                <IconName name="camera_alt" className="icon"/>
                                دوربین عکاسی
                            </span>
                                        <p className="info-product">۱۲.۰ مگاپیکسل</p>
                                    </li>
                                    <li>
                                                        <span className="title-toggle">
                                <IconName name="videocam" className="icon"/>
                                فیلمبرداری
                            </span>
                                        <p className="info-product">رزولوشن 2160 × 3840 و سرعت 24/30/60 فریم بر ثانیه
                                            (2160p@24/30/60FPS)</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-xl-3 xmt-4 d-none d-lg-block">
                        <div className="product-box position-relative xpx-4 xpt-12 xpb-4">
                            <div className="price-box position-absolute">
                                <span className="total-price persian-number">2,760,000 ت</span>
                            </div>
                            <div className="product-img xmb-4">
                                <img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                            </div>
                            <div className="product-title xmb-2">
                                <h3 className="title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                            </div>
                            <div className="color-range xmb-8">
                                <span className="range" style={{background: "#192B3B"}}></span>
                                <span className="range" style={{background: "#F5F8FA"}}></span>
                                <span className="range" style={{background: "#1473E6"}}></span>
                            </div>
                            <div className="show-buy-product xmb-8">
                                <a href="#">
                                    مشاهده و خرید محصول
                                    <IconName name="chevron_left" className="icon"/>
                                </a>
                            </div>
                            <div className="info-product">
                                <ul className="list-unstyled">
                                    <li>
                                         <span className="title-toggle">
                                            <IconName name="aspect_ratio" className="icon"/>
                                         صفحه‌ی نمایش
                                        </span>
                                        <p className="info-product">۶.۱ اینچ • ۸۲۸ × ۱۷۹۲ پیکسل</p>
                                    </li>
                                    <li>
                                              <span className="title-toggle">
                                <IconName name="straighten" className="icon"/>
                                ابعاد و وزن
                            </span>
                                        <p className="info-product">۸.۳ × ۷۵.۷ × ۱۵۰.۹ میلی‌متر• ۱۹۴ گرم</p>
                                    </li>
                                    <li>
                                                                    <span className="title-toggle">
                                <IconName name="battery_charging_full" className="icon"/>
                                مشخصات باتری
                            </span>
                                        <p className="info-product">باتری از نوع لیتیوم-یون با ظرفیت ۳۱۱۰
                                            میلی‌آمپرساعت</p>
                                    </li>
                                    <li>
                                              <span className="title-toggle">
                                <IconName name="memory" className="icon"/>
حافظه و ذخیره سازی                            </span>
                                        <p className="info-product">حافظه داخلی ۱۲۸ گیگ • رم ۴ گیگ</p>
                                    </li>
                                    <li>
                                                      <span className="title-toggle">
                                <IconName name="cpu" className="icon"/>
                                پردازنده
                            </span>
                                        <p className="info-product">Apple A13 Bionic (7 nm+) Chipset</p>
                                    </li>
                                    <li>
                                                             <span className="title-toggle">
                                <IconName name="camera_alt" className="icon"/>
                                دوربین عکاسی
                            </span>
                                        <p className="info-product">۱۲.۰ مگاپیکسل</p>
                                    </li>
                                    <li>
                                                        <span className="title-toggle">
                                <IconName name="videocam" className="icon"/>
                                فیلمبرداری
                            </span>
                                        <p className="info-product">رزولوشن 2160 × 3840 و سرعت 24/30/60 فریم بر ثانیه
                                            (2160p@24/30/60FPS)</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="information-products-responsive d-block d-lg-none">
                    <div className="info-item xmt-6">
                        <div className="info-title">
                                 <span className="title-toggle">
                                            <IconName name="aspect_ratio" className="icon"/>
                                         صفحه‌ی نمایش
                                        </span>
                        </div>
                        <div className="info-list">
                            <ul className="list-unstyled">
                                <li className="item-info">
                                    <div className="title"><span>صفحه نمایش رنگی</span></div>
                                    <div className="status d-flex">
                                        <div><span>بله</span></div>
                                        <div><span>بله</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>صفحه نمایش لمسی</span></div>
                                    <div className="status d-flex">
                                        <div><span>بله</span></div>
                                        <div><span>بله</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>فناوری</span></div>
                                    <div className="status d-flex">
                                        <div><span>IPS</span></div>
                                        <div><span>IPS</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>بازه‌ی صفحه‌نمایش</span></div>
                                    <div className="status d-flex">
                                        <div><span>6.0 اینچ و بزرگتر</span></div>
                                        <div><span>6.0 اینچ و بزرگتر</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>اندازه</span></div>
                                    <div className="status d-flex">
                                        <div><span>6.53 اینچ</span></div>
                                        <div><span>6.53 اینچ</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>رزولوشن</span></div>
                                    <div className="status d-flex">
                                        <div><span>1080 × 2340 پیکسل</span></div>
                                        <div><span>1080 × 2340 پیکسل</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>تراکم پیکسلی</span></div>
                                    <div className="status d-flex">
                                        <div><span>395 پیکسل بر هر اینچ</span></div>
                                        <div><span>395 پیکسل بر هر اینچ</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>بازه‌ی صفحه‌نمایش</span></div>
                                    <div className="status d-flex">
                                        <div><span>6.0 اینچ و بزرگتر</span></div>
                                        <div><span>6.0 اینچ و بزرگتر</span></div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <div className="info-item xmt-6">
                        <div className="info-title">
                                                     <span className="title-toggle">
                                <IconName name="straighten" className="icon"/>
                                ابعاد و وزن
                            </span>
                        </div>
                        <div className="info-list">
                            <ul className="list-unstyled">
                                <li className="item-info">
                                    <div className="title"><span>صفحه نمایش رنگی</span></div>
                                    <div className="status d-flex">
                                        <div><span>بله</span></div>
                                        <div><span>بله</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>صفحه نمایش لمسی</span></div>
                                    <div className="status d-flex">
                                        <div><span>بله</span></div>
                                        <div><span>بله</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>فناوری</span></div>
                                    <div className="status d-flex">
                                        <div><span>IPS</span></div>
                                        <div><span>IPS</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>بازه‌ی صفحه‌نمایش</span></div>
                                    <div className="status d-flex">
                                        <div><span>6.0 اینچ و بزرگتر</span></div>
                                        <div><span>6.0 اینچ و بزرگتر</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>اندازه</span></div>
                                    <div className="status d-flex">
                                        <div><span>6.53 اینچ</span></div>
                                        <div><span>6.53 اینچ</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>رزولوشن</span></div>
                                    <div className="status d-flex">
                                        <div><span>1080 × 2340 پیکسل</span></div>
                                        <div><span>1080 × 2340 پیکسل</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>تراکم پیکسلی</span></div>
                                    <div className="status d-flex">
                                        <div><span>395 پیکسل بر هر اینچ</span></div>
                                        <div><span>395 پیکسل بر هر اینچ</span></div>
                                    </div>
                                </li>
                                <li className="item-info">
                                    <div className="title"><span>بازه‌ی صفحه‌نمایش</span></div>
                                    <div className="status d-flex">
                                        <div><span>6.0 اینچ و بزرگتر</span></div>
                                        <div><span>6.0 اینچ و بزرگتر</span></div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Comparison;
